module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie PageHeader wraps the header of the Page.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;PageHeader&gt;\n    &lt;div&gt;Header content...&lt;/div&gt;\n&lt;/PageHeader&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/PageHeader/README.md
// module id = 374
// module chunks = 0